<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-flex fill-height>
                <div class="logo">
                    <span class="now">now</span><span class="yu">yu</span>

                    <v-btn mt6 primary round @click="signIn()">Login</v-btn>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'login',
        data() {
            return {
                title: 'Login',
            };
        },
        created() {
            if (this.$store.state.route.query.autoLogin) {
                this.$store.commit('auth/AUTHORIZE', this.$store.state.route.query.redirect);
            }
        },
        methods: {
            signIn() {
                this.$store.commit('auth/AUTHORIZE', this.$store.state.route.query.redirect);
            },
        },
    };
</script>

<style>
.backpane {
    background-color: white;
    /*background-color: #37345a;*/
}

.logo {
    font-size: 64px;
    font-weight: 600;
    text-align: center;
}

.logo > .now {
    font-family: Quicksand;
    color: #e50146;
}

.logo > .yu {
    font-family: Quicksand;
    color: #37345a;
}
</style>



// WEBPACK FOOTER //
// Login.vue?3bc635d1